module.exports = __webpack_public_path__ + "_assets/img/permission.5ff2705f.svg";